import React from "react";
import { inject, observer } from "mobx-react";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";

//components
import applicationRouter from "../../hoc/applicationRouter";
import withLocalization from "../../hoc/withLocalization";

//utils
import { dateToTimeFormat, shortDateFormat } from "../../utils/dateFormat";

const PayrollHistoryTable = ({ integrationSyncHistory, t, dateTimeRules }) => {

    const getActionClass = (action) => {
        if (action === 'enabled') return 'text-success';
        if (action === 'system_disabled') return 'text-danger';
        if (action === 'disabled') return 'text-warning';
        return '';
    };

    return (
        <div className="px-2 py-1">
            <Table className='table-sm mb-0' style={{ tableLayout: 'fixed' }}>
                <thead>
                    <tr style={{ fontSize: '10px' }}>
                        <th className="border-0 text-muted fw-normal" style={{ width: '20%', padding: '2px 4px', lineHeight: 1.2, textAlign: 'left' }}>{t('Username')}</th>
                        <th className="border-0 text-muted fw-normal" style={{ width: '20%', padding: '2px 4px', lineHeight: 1.2, textAlign: 'left' }}>{t('Action')}</th>
                        <th className="border-0 text-muted fw-normal" style={{ width: '20%', padding: '2px 4px', lineHeight: 1.2, textAlign: 'left' }}>{t('Date')}</th>
                        <th className="border-0 text-muted fw-normal" style={{ width: '40%', padding: '2px 4px', lineHeight: 1.2, textAlign: 'left' }}>{t('Reason')}</th>
                    </tr>
                </thead>
            </Table>
            <div style={{ maxHeight: '165px', overflowY: 'auto' }}>
                <Table className='table-sm mb-0' style={{ tableLayout: 'fixed' }}>
                    <tbody>
                        {[...integrationSyncHistory].reverse().map((ele, idx) => (
                            <tr key={idx} style={{ fontSize: '11px' }}>
                                <td className='py-1' style={{ width: '20%', textAlign: 'left' }}>{ele.user_name}</td>

                                <td className={`py-1 text-capitalize fw-bold ${getActionClass(ele.action)}`} style={{ width: '20%', textAlign: 'left' }}>
                                    {t(ele.action.replace('_', ' '))}
                                </td>

                                <td className='py-1' style={{ width: '20%', textAlign: 'left' }}>
                                    {shortDateFormat(ele.timestamp, dateTimeRules)} {dateToTimeFormat(ele.timestamp, dateTimeRules)}
                                </td>

                                <td className='py-1' style={{ width: '40%', textAlign: 'left' }}>
                                    {ele.reason ? (
                                        <div className="d-flex align-items-center">
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip id={`tooltip-err-${idx}`}>{t(ele.reason)}</Tooltip>}
                                            >
                                                <i
                                                    className="fa fa-exclamation-circle text-danger me-2 cursor-pointer"
                                                    style={{ fontSize: '1.2em' }}
                                                />
                                            </OverlayTrigger>

                                            <span
                                                className="text-danger text-truncate"
                                                style={{ maxWidth: '250px', display: 'inline-block', verticalAlign: 'middle' }}
                                                title={t(ele.reason)}
                                            >
                                                {t(ele.reason)}
                                            </span>
                                        </div>
                                    ) : ele.isSyncBySystem ? (
                                        <span className="text-muted" style={{ fontStyle: 'italic' }}>
                                            {t('Auto')} {t(ele.action)} {t('by')} {t('System')} {t('during')}{" "}
                                            {t(ele.entity_status === 'reset' ? 'Reset' : ele.entity_status)}
                                        </span>
                                    ) : (
                                        <span className="text-muted" style={{ fontStyle: 'italic' }}>
                                            {t('Manually')} {t(ele.action)} {t('by')} {ele.user_name || ele.user_id} {t('during')}{" "}
                                            {t(ele.entity_status === 'reset' ? 'Reset' : ele.entity_status)}
                                        </span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default inject('commonStore')(applicationRouter(withLocalization(observer(PayrollHistoryTable))));